// removed by extract-text-webpack-plugin
module.exports = {"LoginLink":"UserMenu__LoginLink__EWGmv","LoginLinkActive":"UserMenu__LoginLinkActive__sl2M1","logoLink":"UserMenu__logoLink__2AmBk","ListItem":"UserMenu__ListItem__3FDYO","Menu":"UserMenu__Menu__3XNVl","showMenu":"UserMenu__showMenu__knnK6","MenuTag":"UserMenu__MenuTag__w4EYT","Greeting":"UserMenu__Greeting__2I3T_","DrawerMenu":"UserMenu__DrawerMenu__1tzIe"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserMenu/UserMenu.css
// module id = 94
// module chunks = 0